import React, {Component} from 'react';
import '../App.css';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

class AppInfo extends Component{

  constructor(props){
    super(props);
    this.app= firebase;
    this.database = this.app.firestore().collection('Info');
    this.db = this.app.firestore().collection('otrosProyectos');
    this.state = {
      nombre: '',
      projectos: [],
    }
  }
  
  componentDidMount(){
    this.database.doc('info').onSnapshot((doc)=>{
        if(doc.exists)
          this.setState({nombre: doc.data().nombre})
    })
    this.db.onSnapshot(querySnapshot =>{
        this.setState({projectos:[]})
        querySnapshot.forEach(doc=>{
            if(!doc.exists) return null
            const previousAct = this.state.projectos;
            previousAct.push({
            id: doc.id,
            nombre: doc.data().nombre,
            link: doc.data().link,
            })
            this.setState({
                projectos: previousAct
            })
        })
    })

  }
  
  render(){
    return (
    <div className = "Titulo-del-Proyecto inline">
      <div className = "links">
      {
      this.state.projectos.map((projecto) => 
        {
            return(
            <button className='active' key={projecto.id}><a  href={projecto.link}>Ir a {projecto.nombre} </a></button>
            )
        })
      }
      </div>
    </div>
    
    )
  }
}

export default AppInfo;